import request from '@/utils/request'

export function updatePassword(param) {
    let data = param
    return request({
        url: `/supplier/chgPwd/updatePassword`,
        method: 'POST',
        meta: { apiVersion: '1.0.0' },
        headers: { 'Content-Type': 'application/json;charset=utf8' },
        data
    })
}